module.exports = "<div *ngIf=\"(group$ | async)?.logoPictureUrl?.length\" class=\"app-header-logo\">\n  <img [src]=\"(group$ | async)?.logoPictureUrl\" />\n</div>\n<a (click)=\"switchLanguage()\">{{ 'switch_language_short' | translate }}</a>\n"


//////////////////
// WEBPACK FOOTER
// ./ng2/shared/app-header/app-header.component.html
// module id = 1205
// module chunks = 0